import React, { ComponentProps } from 'react';

import ContentLoader from '@adsk/alloy-react-content-loader';

import ActivityCard from '../ActivityCard';

const renderNothing = () => null;

type ActivityCardLoaderProps = ComponentProps<typeof ActivityCard>;

/**
 * ActivityCardLoader component. Describes a loading state of a single activity card.
 */
const ActivityCardLoader = React.forwardRef<
  HTMLDivElement,
  ActivityCardLoaderProps
>((props, ref) => {
  return (
    <ActivityCard
      ref={ref}
      renderHeader={renderNothing}
      {...props}
      user={undefined}
      date={undefined}
    >
      <ContentLoader width={227} height={66}>
        <rect x="0" y="8" rx="6" ry="6" width="66" height="8" />
        <rect x="0" y="32" rx="6" ry="6" width="227" height="8" />
        <rect x="0" y="56" rx="6" ry="6" width="156" height="8" />
      </ContentLoader>
    </ActivityCard>
  );
});

ActivityCardLoader.displayName = 'ActivityCardLoader';

ActivityCardLoader.propTypes = {
  ...ActivityCard.propTypes,
};

export default ActivityCardLoader;
